import React, { useState, useEffect, useRef } from 'react';

const testimonials = [
  {
    text: "Since using KinOS, I've been consistently tracking my meals with just a quick photo. It's helped me make better food choices without the hassle of logging every ingredient.",
    author: "Rachel K.",
    role: "Busy Parent",
    avatar: "/avatar1.png"
  },
  {
    text: "The voice journaling feature has been a game-changer for my mental health. Taking 30 seconds to record how I'm feeling has given me incredible insights about my mood patterns.",
    author: "Marco T.",
    role: "Tech Professional",
    avatar: "/avatar2.png"
  },
  {
    text: "KinOS makes exercise tracking effortless. I've maintained a consistent routine for 3 months now - the longest streak I've ever had with a wellness app!",
    author: "Vivian L.",
    role: "Marketing Executive",
    avatar: "/avatar3.png"
  },
  {
    text: "The Apple Health integration means I don't have to manually input data from my watch. Everything syncs automatically, saving me time while giving me a complete picture of my health.",
    author: "Sean R.",
    role: "Fitness Enthusiast",
    avatar: "/avatar4.png"
  },
  {
    text: "The intelligent insights have helped me see connections between my diet, exercise, and mood that I never noticed before. My sleep has improved dramatically as a result.",
    author: "Kim W.",
    role: "Healthcare Worker",
    avatar: "/avatar5.png"
  },
  {
    text: "I love how KinOS sends gentle reminders based on my patterns. When I miss my usual walking time, it checks in without making me feel guilty.",
    author: "Amina B.",
    role: "Remote Worker",
    avatar: "/avatar6.png"
  },
  {
    text: "Having access to a human coach through KinOS has kept me accountable. The coach reviews my data and gives personalized advice that generic apps simply can't provide.",
    author: "Peter S.",
    role: "Wellness Journey",
    avatar: "/avatar1.png"
  },
  {
    text: "The holistic approach is what keeps me using KinOS daily. Seeing how my nutrition, movement, and mood interconnect has been eye-opening for my overall wellbeing.",
    author: "Joanne G.",
    role: "Mindfulness Practitioner",
    avatar: "/avatar2.png"
  },
  {
    text: "I've tried dozens of health apps, but KinOS is the only one I've stuck with long-term. The simplicity of tracking combined with meaningful insights makes all the difference.",
    author: "Carlos M.",
    role: "Busy Professional",
    avatar: "/avatar3.png"
  }
];

const TestimonialsClient = () => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const scrollRef = useRef(null);
  
  useEffect(() => {
    const scrollContainer = scrollRef.current;
    let animationFrameId;
    let scrolling = true;
    
    const scroll = () => {
      if (!scrollContainer || !scrolling) return;
      
      setScrollPosition(prev => {
        const newPosition = prev + 0.5;
        if (newPosition >= scrollContainer.scrollWidth - scrollContainer.clientWidth) {
          return 0; // Reset to start
        }
        return newPosition;
      });
      
      scrollContainer.scrollLeft = scrollPosition;
      animationFrameId = requestAnimationFrame(scroll);
    };

    animationFrameId = requestAnimationFrame(scroll);
    
    const handleMouseEnter = () => {
      scrolling = false;
    };

    const handleMouseLeave = () => {
      scrolling = true;
      requestAnimationFrame(scroll);
    };

    scrollContainer.addEventListener('mouseenter', handleMouseEnter);
    scrollContainer.addEventListener('mouseleave', handleMouseLeave);
    
    return () => {
      cancelAnimationFrame(animationFrameId);
      if (scrollContainer) {
        scrollContainer.removeEventListener('mouseenter', handleMouseEnter);
        scrollContainer.removeEventListener('mouseleave', handleMouseLeave);
      }
    };
  }, [scrollPosition]);

  return (
    <section id="testimonials" className="py-16 sm:py-24 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex items-center justify-center mb-2">
          <span className="text-3xl">💚</span>
        </div>
        <h2 className="text-3xl sm:text-4xl font-bold text-center mb-4">
          Real Results with Holistic Tracking
        </h2>
        <p className="text-lg text-center text-gray-600 mb-12">
          See how KinOS users are transforming their wellness journey with simplified tracking
        </p>

        <div className="relative overflow-hidden">
          {/* Scrolling Container */}
          <div 
            ref={scrollRef}
            className="flex gap-4 sm:gap-6 whitespace-nowrap overflow-x-hidden"
          >
            {[...testimonials, ...testimonials].map((testimonial, index) => (
              <div 
                key={index}
                className="inline-flex flex-none w-[280px] sm:w-[350px] bg-white rounded-2xl p-4 sm:p-6 shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1"
              >
                <div className="overflow-hidden">
                  <p className="text-gray-800 mb-4 sm:mb-6 text-sm sm:text-base leading-relaxed whitespace-normal">
                    "{testimonial.text}"
                  </p>
                  <div className="flex items-center gap-3">
                    <div>
                      <p className="font-medium text-sm sm:text-base">{testimonial.author}</p>
                      <p className="text-emerald-700 text-xs sm:text-sm">{testimonial.role}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="absolute left-0 top-0 bottom-0 w-12 sm:w-20 bg-gradient-to-r from-gray-50 to-transparent pointer-events-none" />
          <div className="absolute right-0 top-0 bottom-0 w-12 sm:w-20 bg-gradient-to-l from-gray-50 to-transparent pointer-events-none" />
        </div>
        
        <div className="mt-12 text-center">
          <a 
            href="https://apps.apple.com/us/app/hyphii-healthy-lifestyle-app/id6737209270" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="inline-block bg-black hover:bg-emerald-600 text-white font-medium py-3 px-8 rounded-xl shadow-sm hover:shadow-md transition-all duration-300"
          >
            Download the App
          </a>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsClient;